import { encode, encodeSync } from './encode';
import { writeFile, writeFileSync } from '../fetch/write-file';
export function save(data, url, writer, options) {
  var encodedData = encode(data, writer, options, url);
  return writeFile(url, encodedData);
}
export function saveSync(data, url, writer, options) {
  var encodedData = encodeSync(data, writer, options, url);
  return writeFileSync(url, encodedData);
}
//# sourceMappingURL=save.js.map


// WEBPACK FOOTER //
// ./~/@loaders.gl/core/dist/esm/lib/api/save.js